import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/finished";
import Modal from "@/atomic/atoms/Modal";
import TicketModal from "@/atomic/organisms/TicketModal";
import Loading from "@/atomic/atoms/Loading";
import useI18n from "@/hooks/useI18n";
import PlanSelection from "@/atomic/organisms/PlanSelection";
import { useThemeContext } from "@/contexts/ThemeContext";

export default function CheckoutFinishedView({
  goBack,
  invoice,
  toggleModal,
  generatePDF,
  isVisibleModal,
  isLoading,
  openInvoice,
  error,
  toggleError,
  toggleModalRegister,
  handleTryAgain,
}: PropsView) {

  const { t } = useI18n();
  const { themeName, theme } = useThemeContext();
  const isZapay = themeName === 'zapay';
  const title = themeName === 'zapay' ? 'Pedágio' : 'Pagamento';

  return (
    <div className="h-full">
      <Header
        title={title}
        hasLeftButton
        goBack={goBack}
      />
       

        <main className="px-4 py-3 md:py-6 flex justify-center items-center h-[calc(100vh-72px)] overflow-y-auto bg-white">
        <article className="h-full flex flex-col w-full items-center justify-between">
          <div className="flex flex-col w-full max-w-[1400px] mx-auto flex-1 justify-center">
            {isZapay ? (
              <>
                <div 
                  className="flex items-center justify-center w-full flex-col flex-shrink-0"
                >
                  <div style={{ marginBottom: theme.spacing.large }}>
                    <img 
                      src="/svg/payment-success-ilustration.svg" 
                      alt={t("pages:success:paymentSuccessTitle")} 
                      className="w-20 h-20 md:w-24 md:h-24"
                    />
                  </div>
                  <h2 
                    className="text-2xl md:text-3xl font-primary font-bold text-center mb-3 leading-tight"
                    style={{ 
                      color: theme.colors.text,
                      fontFamily: theme.fonts.primary
                    }}
                  >
                    {t("pages:success:paymentSuccessTitle")}
                  </h2>
                  <h3 
                    className="text-sm md:text-base text-center px-2 max-w-md"
                    style={{ 
                      color: theme.colors.textSecondary,
                      fontFamily: theme.fonts.primary
                    }}
                  >
                    {t("pages:success:paymentSuccessDescription")}
                  </h3>
                </div>
              </>
            ) : (
              <>
                <div className="flex items-center justify-center w-full flex-col mb-4 md:mb-6">
                  <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-2 md:mb-3">
                    <svg className="w-10 h-10 md:w-12 md:h-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <h2 className="text-xl md:text-3xl font-bold text-black text-center mb-1 md:mb-2">Sucesso!</h2>
                  <h3 className="text-xs md:text-base text-center text-[#525252] px-2">Seu pagamento foi realizado.</h3>
                </div>
                
                <div className="flex justify-center items-center w-full mx-auto mb-3 md:mb-6">
                  <PlanSelection />
                </div>

                <div className="w-full max-w-full md:w-[calc(480px)] mx-auto">
                  <div className="flex items-center flex-col mt-8 md:mt-6 px-2">
                    <button onClick={openInvoice} type="button" className="w-full h-[calc(60px)] rounded-lg border bg-transparent border-black text-black font-medium mb-4">{t("pages:success:receipt")}</button>
                    <button onClick={goBack} type="button" className="w-full h-[calc(60px)] rounded-lg bg-transparent text-black font-medium">{t("pages:success:exit")}</button>
                  </div>
                </div>
              </>
            )}
          </div>
          
          {isZapay && (
            <div className="w-full max-w-full md:w-[calc(480px)] mx-auto flex-shrink-0 pb-8">
              <div className="flex items-center flex-col px-2">
                <button 
                  onClick={goBack} 
                  type="button" 
                  className="w-full h-[calc(60px)] text-white font-medium mb-4"
                  style={{ 
                    backgroundColor: theme.colors.primary,
                    borderRadius: theme.borderRadius.medium,
                    fontFamily: theme.fonts.primary
                  }}
                >
                  {t("pages:success:goToHome")}
                </button>
                <button 
                  onClick={openInvoice} 
                  type="button" 
                  className="w-full font-medium bg-transparent"
                  style={{ 
                    color: theme.colors.primary,
                    fontFamily: theme.fonts.primary
                  }}
                >
                  {t("pages:success:viewReceipt")}
                </button>
              </div>
            </div>
          )}
        </article>
      </main>
      {isLoading && <Loading />}
      {isVisibleModal && invoice && (
        <TicketModal
          invoice={invoice}
          generatePDF={generatePDF || (() => {})}
          toggleModal={toggleModal || (() => {})}
          toggleModalRegister={toggleModalRegister || (() => {})}
        />
      )}
      {error && (
        <Modal
          title="Ops"
          message={t("pages:receipt:description")}
          actionMessage={t("pages:receipt:checkAgain")}
          action={handleTryAgain}
          actionSecond={toggleError}
          actionSecondMessage={t("common:close")}
          actionClassName={isZapay ? `w-full py-4 text-white text-lg mb-4 font-medium` : "w-full bg-black py-4 rounded-xl text-white text-lg mb-4"}
          actionSecondClassName={isZapay ? `mb-2 font-medium` : "text-black underline mb-2"}
          actionStyle={isZapay ? {
            backgroundColor: theme.colors.primary,
            borderRadius: theme.borderRadius.medium,
            fontFamily: theme.fonts.primary
          } : undefined}
          actionSecondStyle={isZapay ? {
            color: theme.colors.primary,
            fontFamily: theme.fonts.primary
          } : undefined}
        />
      )}
    </div>
  );
}
